import axios from 'axios'
import { API_URL } from 'constants/global.constants'

interface GetHistoryParams {
  subscriptionCompanyId: number;
  page?: number;
  limit?: number;
}

interface LogAction {
  id: number;
  subscription_company_id: number;
  action: string;
  formatted_action: string;
  previous_state: {
    state: boolean;
    credits: number;
    tests_used: number;
    expiration_date: string;
  } | null;
  new_state: {
    state: boolean;
    credits: number;
    tests_used: number;
    expiration_date: string;
    name?: string;
  };
  notes: string;
  created_at: string;
  user: {
    id: number;
    name: string;
    email: string;
  };
}

interface HistoryResponse {
  status: string;
  data: {
    logs: LogAction[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      total_pages: number;
    };
  };
}

/**
 * Obtiene el historial de modificaciones de un inventario
 * @param params Parámetros para obtener el historial
 * @returns Promesa con el resultado de la operación
 */
export const getSubscriptionCompanyHistory = async (params: GetHistoryParams): Promise<HistoryResponse> => {
  const { subscriptionCompanyId, page = 1, limit = 10 } = params

  try {
    const response = await axios.get(
      `${API_URL}/subscription_company/${subscriptionCompanyId}/history`,
      {
        params: {
          page,
          limit
        },
        headers: {
          Authorization: localStorage.getItem('token')
        }
      }
    )

    return response.data
  } catch (error: any) {
    console.error('Error al obtener el historial de modificaciones:', error)

    // Log de detalles del error si están disponibles
    if (error.response?.data) {
      console.error('Detalle del error:', error.response.data)
    }

    throw error
  }
}
